export const setIsLogged = () => localStorage.setItem('isLogged', 'true');

export const isLogged = () => localStorage.getItem('isLogged') === 'true';

export const deleteIsLogged = () => localStorage.removeItem('isLogged');

export const logout = () => localStorage.clear();
